import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";
import CaretDown from "../../../../../../../assets/svg/icons/common/CaretDown";
import DarkCross from "../../../../../../../assets/svg/icons/common/dark-cross";

const statuses = [
  { label: "Draft", value: "draft", color: "gray" },
  { label: "In Progress", value: "in-progress", color: "purple" },
  { label: "Unworkable", value: "unworkable", color: "brown" },
  { label: "App Started", value: "app-started", color: "light-blue" },
  { label: "Sent to Signature", value: "sent-to-signature", color: "blue" },
  { label: "Signed", value: "signed", color: "navy" },
  { label: "Underwriting", value: "underwriting", color: "yellow" },
  { label: "Pending Docs", value: "pending-docs", color: "orange" },
  { label: "Approved", value: "approved", color: "green" },
  { label: "Declined", value: "declined", color: "red" },
  { label: "Cancelled", value: "cancelled", color: "dark-red" },
];

const progression_options = [
  {
    value: 1,
    label: "Back to Edit",
    color: "orange",
  },
  {
    value: 7,
    label: "Sent for Signature",
    color: "#f0be74",
  },
  {
    value: 8,
    label: "Signed - PC Review",
    color: "#819FEC",
  },
  {
    value: 9,
    label: "Underwriting Review",
    color: "#7FCECE",
  },
  {
    value: 10,
    label: "Pended",
    color: "#E7B8DF",
  },
  {
    value: 11,
    label: "Awaiting Reserve",
    color: "#44AE42",
  },
  {
    value: 12,
    label: "Approved",
    color: "#44AE42",
  },
  {
    value: 13,
    label: "Denied",
    color: "#FFA500",
  },
  {
    value: 14,
    label: "Cancelled",
    color: "#660000",
  },
  {
    value: 15,
    label: "App pending PC approval",
    color: "#44AE42",
  },
  {
    value: 17,
    label: "PDF requested",
    color: "#F0BE74",
  },
  {
    value: 18,
    label: "Awaiting wet signature",
    color: "#F0BE74",
  },
  {
    value: 21,
    label: "Terminated",
    color: "#FF0000",
  },
  {
    value: 22,
    label: "Support",
    color: "#0000FF",
  },
];

const statusColorMapping = {
  1: "orange",
  2: "orange",
  3: "orange",
  4: "orange",
  5: "orange",
  6: "orange",
  7: "#f0be74",
  8: "#819FEC",
  9: "#7FCECE",
  10: "#E7B8DF",
  11: "#44AE42",
  12: "#44AE42",
  13: "#FFA500",
  14: "#660000",
  15: "#44AE42",
  17: "#F0BE74",
  18: "#F0BE74",
  19: "#c5c5c5",
  20: "#c5c5c5",
  21: "#F0BE74",
  22: "#0000FF",
};

const Progression = ({ selectedStatuses = [], onChange, options = [] }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selected, setSelected] = useState(selectedStatuses);

  useEffect(() => {
    setSelected(selectedStatuses);
  }, [selectedStatuses]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleStatusToggle = (status) => {
    const updatedStatuses = selected.includes(status)
      ? selected.filter((s) => s !== status)
      : [...selected, status];

    setSelected(updatedStatuses);
    if (onChange) {
      onChange(updatedStatuses);
    }
  };

  const handleRemoveStatus = (statusToRemove) => {
    const updatedStatuses = selected.filter(
      (status) => status !== statusToRemove,
    );
    setSelected(updatedStatuses);
    if (onChange) {
      onChange(updatedStatuses);
    }
  };

  const getAvailableStatuses = () => {
    return options.filter((status) => !selected.includes(status.value));
  };

  return (
    <div className={styles.progressionContainer}>
      <label>Progression</label>
      <div
        className={styles.tagsContainer}
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        {options
          .filter((status) => selected.includes(status.value))
          .map((status) => (
            <div
              key={status.value}
              className={`${styles.tag}`}
            >
              <span className={styles.dot} style={{ backgroundColor: statusColorMapping[status.value] }}></span>
              <span className={styles.label}>{status.label}</span>
              <button
                className={styles.removeButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveStatus(status.value);
                }}
              >
                <DarkCross />
              </button>
            </div>
          ))}

        <div className={styles.dropdownToggle}>
          <div className={`${styles.caret} ${dropdownOpen && styles.open}`}>
            <CaretDown />
          </div>
        </div>
      </div>

      {dropdownOpen && (
        <div className={styles.dropdown} ref={dropdownRef}>
          {getAvailableStatuses().map((status) => (
            <div
              key={status.value}
              className={styles.dropdownItem}
              onClick={() => {
                handleStatusToggle(status.value);
                setDropdownOpen(false);
              }}
            >
              <span className={`${styles.dot}`} style={{ backgroundColor: statusColorMapping[status.value], marginRight: "8px" }} ></span>
              <span>{status.label}</span>
            </div>
          ))}

          {(!getAvailableStatuses() || getAvailableStatuses().length === 0) && (
            <div
              key={"no-option-progression"}
              className={styles.dropdownItem}
              onClick={() => {
                setDropdownOpen(false);
              }}
            >
              <span>No options</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Progression;
